<template>
  <v-container
    class="fill-height bg"
    fluid
  >
    <v-row 
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="">
          <v-toolbar
            color="teal lighten-2"
            dark
            flat
          >
            <v-toolbar-title class="headline">Reset Password</v-toolbar-title>                        
          </v-toolbar>
          <v-card-subtitle class="subtitle-1">Masukkan User ID atau E-Mail!</v-card-subtitle>
          <v-spacer />
          <v-card-text>
            <v-form ref="home">
              <v-text-field
                label="User ID /  E-Mail"
                name="userId"
                prepend-icon="person"
                type="text"
                v-model="userId"
                :rules="[rules.required]"
                v-on:keyup.enter="submitClick"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>              
                <v-col cols="12">
                  <v-btn dark color="green" @click="submitClick" v-if="!daftarDone">Kirim E-mail Reset Password</v-btn>
                  <v-btn color="blue" dark click="" to="/" class="mx-2">{{ Batal }}</v-btn>
                </v-col>
              </v-row>  
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>      
  </v-container>
</template>

<script>
import { rules as Rules } from './../../lib/rules'
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'

export default {
  data: function() {
    return {
      userId: '',
      rules: {
        required: Rules.required,
      },
      batal: 'Batal',
      daftarDone: false,
    }
  },
  computed: {
    Batal: function() {
      return this.daftarDone ? 'Kembali ke Home' : 'Batal'
    }
  },
  methods: {
    submitClick: async function() {
      this.$store.dispatch('displayProgBar')
      await axios.post(apiUrl+'/userman/forget', { userId: this.userId })
      .then(response => {
        console.log(response)
        this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Email Reset password sudah dikirim !` })
        window.scroll(0,0)
        this.daftarDone = true
      })
      .catch(error => {
        this.$store.dispatch('displayAlert', {color: 'error', message: error.response.data.message})
        window.scroll(0,0)
      })
      .finally(() => {
        this.$store.dispatch('closeProgBar')
      }) 
    }
  }
}
</script>

<style scoped>

</style>